import { z } from 'zod'

const EnvSchema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_DOMAIN_URL: z.string().url(),
  VITE_ENVIRONMENT: z.enum(['local', 'preview', 'production']),
  VITE_BRASIL_API_URL: z.string().url(),
})

export const env = EnvSchema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_DOMAIN_URL: import.meta.env.VITE_DOMAIN_URL,
  VITE_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  VITE_BRASIL_API_URL: import.meta.env.VITE_BRASIL_API_URL,
})
